<template>
    <div class="collate-half-content">
        <!-- 1. 课程中心 -->
        <div class="collate-half-content-box" v-if="homeCourseList && homeCourseList.length>0">
            <div class="collate-half-content-title">
                <span class="c-title">课程中心</span>
                <i class="c-icon iconfont icon-more" @click="clickMore(1)"></i>
            </div>
            <div class="collate-half-content-course dsp-flex">
                <div class="collate-half-content-course-box1" :style="homeCourseList[0].f_pic ? 'background-image: url('+homeCourseList[0].f_pic+')' : ''" @click="clickCourse(0)"></div>
                <div class="collate-half-content-course-box2">
                    <div class="collate-half-content-course-box3" :style="homeCourseList[1].f_pic ? 'background-image: url('+homeCourseList[1].f_pic+')' : ''" @click="clickCourse(1)"></div>
                    <div class="collate-half-content-course-box4" :style="homeCourseList[2].f_pic ? 'background-image: url('+homeCourseList[2].f_pic+')' : ''" @click="clickCourse(2)"></div>
                </div>
            </div>
        </div>
        <!-- 2. 热门名人八字 -->
        <div class="collate-half-content-box" v-if="homeFamousPediaList && homeFamousPediaList.length>0">
            <div class="collate-half-content-title">
                <span class="c-title">热门名人八字</span>
                <i class="c-icon iconfont icon-more" @click="clickMore(2)"></i>
            </div>
            <div class="collate-half-content-famous-pedia-list">
                <div class="collate-half-content-famous-pedia-list-item" v-for="(item, index) in homeFamousPediaList" v-bind:key="item.id+index" :class="'item'+(index%4)" @click="clickFamousItem(item)">
                    <div class="pedia-list-item-bg" :style="item.f_cover ? 'background-image: url('+item.f_cover+')' : ''"></div>
                    <div class="pedia-list-item-name">
                        <p class="name-text1">{{ item.f_name }}</p>
                        <p class="name-text2"><span>{{ item.f_title }}</span></p>
                    </div>
                    <div class="pedia-list-item-eight-word">
                        <span class="eight-word-span" v-for="(bzData) in item.bzList" v-bind:key="bzData[0]+Math.random(0,10)">
                            {{ bzData[0].text }}{{ bzData[1].text }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 3. 热门论盘 -->
        <div class="collate-half-content-box" v-if="homeDiscussList && homeDiscussList.length>0">
            <div class="collate-half-content-title">
                <span class="c-title">热门论盘</span><i class="iconbg icon-hot"></i>
                <i class="c-icon iconfont icon-more" @click="clickMore(3)"></i>
            </div>
            <div class="collate-half-content-discuss-list">
                <discuss-main-item v-for="(item, index) in homeDiscussList" v-bind:key="item.id+index" v-bind:source="item"></discuss-main-item>
            </div>
        </div>
        <!-- 4. 电子书 -->
        <div class="collate-half-content-box" v-if="homeEbookList && homeEbookList.length>0">
            <div class="collate-half-content-title">
                <span class="c-title">电子书</span>
                <i class="c-icon iconfont icon-more" @click="clickMore(4)"></i>
            </div>
            <div class="collate-half-content-ebook-list">
            </div>
        </div>

        <!-- 5. 推荐阅读 -->
        <div class="collate-half-content-box last" v-if="homeArticleList && homeArticleList.length>0">
            <div class="collate-half-content-title">
                <span class="c-title">推荐阅读</span>
                <i class="c-icon iconfont icon-more" @click="clickMore(5)"></i>
            </div>
            <div class="collate-half-content-ebook-list">
            </div>
        </div>

        <div class="collate-half-content-note">
            <i class="iconfont icon-qipan2"></i>大师我是有底线的...
        </div>
    </div>
</template>

<script>
import reminder from '../../modules/store/modules/reminder';
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
import { DOM, LOADING_DOM } from '../../modules/dom'
import { MIX } from '../../modules/utils';
import DiscussMainItem from '../../components/discuss/DiscussMainItem.vue'
import Discuss from '../../pages/Discuss.vue';
export default {
    name: 'CollateHalfContent',
    components: { DiscussMainItem, Discuss },
    computed: {
        homeCourseList() {
            return this.$store.state.homeCourseList;
        },
        homeFamousPediaList() {
            return this.$store.state.homeFamousPediaList;
        },
        homeDiscussList() {
            return this.$store.state.homeDiscussList;
        },
        homeEbookList() {
            return this.$store.state.homeEbookList;
        },
        homeArticleList() {
            return this.$store.state.homeArticleList;
        },
    },
    data(){
        return {
            
        }
    },
    mounted: function() {
    },
    methods:{
        clickMore(type) {
            switch(type) {
                case 1:
                    this.$router.replace('/courselist/collate');
                    break;
                case 2:
                    this.$router.replace('/famouspedia');
                    break;
                case 3:
                    this.$router.replace('/discussmain');
                    break;
                case 4:
                    this.$router.replace('/library/collate');
                    break;
                case 5:
                    this.$router.replace('/reading/collate');
                    break;
            }
        },
        clickCourse(index) {
            if(this.homeCourseList && this.homeCourseList.length>index) {
                let courseData = this.homeCourseList[index];
                if(courseData && courseData.id) {
                    this.$store.state.course.courseListPageFrom = 'collate_home';
                    this.$router.replace('/coursedetail/'+courseData.id);
                } else {
                    this.$toast('课程数据异常');
                }
            } else {
                this.$toast('课程数据异常');
            }
        },
        clickFamousItem(data) {
            LOADING_DOM.showLoading();
            var me = this;
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: false,
                baikeId: data.id,
                baikeType: data.type,
                baikeStatus: data.status,
                sucCb: function(curEditType) {
                    if(curEditType == CONST_FAMOUS_PEDIA_EDIT_TYPE.read) {
                        me.$router.replace('/famouspediaread/' + data.id + '/collate')
                    }else {
                        me.$router.replace('/famouspediaedit')
                    }
                    LOADING_DOM.hideLoading();
                },
                failCb: function() {
                    me.$toast('没有找到这个八字的百科数据');
                    LOADING_DOM.hideLoading();
                }
            })

        }
    }
}
</script>